import { useLayoutEffect, useRef } from "react";
const lockedOverflow = "hidden";
/**
 * if `toggleLock` is undefined, the body scroll is locked when hook is mounted
 * and unlocked when hook in unmounted. otherwise the lock is toggled depending
 * on the value of `toggleLock`.
 */
const useLockBodyScroll = (toggleLock) => {
    const originalOverflow = useRef(window.getComputedStyle(document.body).overflow);
    useLayoutEffect(() => {
        if (toggleLock === undefined) {
            document.body.style.overflow = lockedOverflow;
        }
        else {
            document.body.style.overflow = toggleLock ? lockedOverflow : originalOverflow.current;
        }
        return () => {
            document.body.style.overflow = originalOverflow.current;
        };
    }, [toggleLock]);
};
export default useLockBodyScroll;
//# sourceMappingURL=useLockBodyScroll.js.map